<script>
import { apiSecond } from '@/boot/axios'

import MainFilters from '@/components/MainFilters.vue'

export default {
	name: 'SpvCheckTirHistory',
	components: { MainFilters },
	data() {
		return {
			headers: [
				{ text: 'Id', value: 'id', sortable: false, width: '45px' },
				{ text: this.$t('headers.fio'), value: 'user', width: '5vw', sortable: false },
				{ text: this.$t('headers.iin_bin'), value: 'bin', sortable: false, width: '8vw' },
				{ text: this.$t('headers.pool'), value: 'pool', sortable: false },
				{ text: this.$t('headers.region'), value: 'region', sortable: false },
				{ text: this.$t('headers.date'), value: 'created_at', sortable: false },
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '200px',
				},
			],
			headersList: [
				{ text: this.$t('spv_check.species'), value: 'fish_type', sortable: false },
				{ text: this.$t('spv_check.limit_kg'), value: 'limit', width: '5vw', sortable: false },
				{
					text: this.$t('spv_check.epj_volume_kg'),
					value: 'trade_volume',
					sortable: false,
					width: '8vw',
				},
				// У проверок до появления «Выдано СПВ» поля null — показываем как в PDF: выдано 0, доступно = ЭПЖ
				{ text: this.$t('spv_check.allocated_kg'), value: 'allocated_volume', sortable: false },
				{ text: this.$t('spv_check.available_kg'), value: 'available_volume', sortable: false },
				{ text: this.$t('spv_check.requested_kg'), value: 'requested_volume', sortable: false },
				{ text: this.$t('spv_check.status'), value: 'status', sortable: false },
				{
					text: this.$t('spv_check.coverage'),
					value: 'coating',
					sortable: false,
				},
			],
			list: [],
			listMeta: {
				total: 0,
			},
			selected: null,
			loading: false,
			errorMessage: {
				status: null,
				text: null,
			},
		}
	},
	computed: {
		getFilters() {
			return ['iin_bin', 'regions', 'pools']
		},
		query() {
			return this.$route.query
		},
		options: {
			get() {
				return {
					page: Number(this.$route?.query?.page || 1),
					itemsPerPage: Number(this.$route?.query?.per_page || 5),
				}
			},
			set(options) {
				this.$router.replace({
					query: {
						...this.$route.query,
						page: options.page,
						per_page: options.itemsPerPage,
					},
				})
			},
		},
	},
	watch: {
		query: {
			handler() {
				this.apiGetList()
			},
		},
		immediate: true,
	},
	methods: {
		async apiGetList() {
			try {
				this.loading = true

				const query = {
					...this.$route.query,
					page: this.$route?.query?.page || 1,
					per_page: this.$route?.query?.per_page || 5,
				}
				if (query['filterTime']) delete query['filterTime']
				const response = await apiSecond.get('/v1/spv-check', {
					params: query,
				})
				if (response?.data?.data) {
					this.list = response.data.data.data
					this.listMeta = {
						total: response.data.data.total,
					}
				}
			} catch (error) {
				this.catchError(error)
			} finally {
				this.loading = false
			}
		},
		catchError(error) {
			if (error?.response?.status == 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			}
			if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error.response.data.error_messages
				this.$router.push('/' + this.$i18n.locale + '/login')
			}
			if (error?.response?.status == 422) {
				this.errorMessage.status = 422
				this.errorMessage.messages = error.response.data.error_messages
			}
			if (error?.response?.status == 403) {
				this.errorMessage.status = 403
				this.errorMessage.text = error?.response?.data?.message
			}
		},
		downloadPdfReport(id) {
			apiSecond
				.get(`/v1/spv-check/${id}/pdf`, {
					responseType: 'blob',
				})
				.then((response) => {
					const blob = new Blob([response.data], { type: 'application/pdf' })
					let fileURL = window.URL.createObjectURL(blob)
					let fileLink = document.createElement('a')
					fileLink.href = fileURL
					const extensions = {
						'application/pdf': 'pdf',
					}
					const contentType = response.headers['content-type']
					const extension = extensions[contentType]
					const filename = `report-${id}.${extension}`

					fileLink.setAttribute('download', filename)
					document.body.appendChild(fileLink)

					fileLink.click()
					fileLink.remove()
				})
				.catch(() => {})
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	beforeMount() {
		const { page, per_page } = this.$route.query
		this.$router
			.replace({
				query: {
					...(page ? { page } : {}),
					...(per_page ? { per_page } : {}),
				},
			})
			.catch(() => {})
	},
}
</script>

<template>
	<div>
		<MainFilters
			:filter-keys="getFilters"
			:filterOptions="{
				pools: { multiple: true },
				regions: { multiple: true },
			}"
			class="grow mb-3"
		/>
		<div class="table__block--content">
			<v-data-table
				:headers="headers"
				:items="list"
				:server-items-length="listMeta.total"
				:loading="loading"
				:footer-props="{
					'items-per-page-options': [5, 10, 20, 30, 40, 50],
				}"
				:options.sync="options"
			>
				<template #item.user="{ item }">
					{{ item?.tir?.first_name }} {{ item?.tir?.last_name }}
					{{ item?.tir?.middle_name }}
				</template>
				<template #item.bin="{ item }">
					{{ item?.tir?.iin_bin }}
				</template>
				<template #item.pool="{ item }">
					<div v-for="pool in item?.user?.pools || []" :key="pool.id">
						{{ pool?.title }}
					</div>
				</template>
				<template #item.region="{ item }">
					<div v-for="region in item?.user?.regions || []" :key="region.id">
						{{ $i18n.locale == 'kz' ? region?.region?.title_kz : region?.region?.title }}
					</div>
				</template>
				<template #item.created_at="{ item }">
					{{
						`${new Date(item?.created_at).toLocaleDateString()} ${new Date(
							item?.created_at,
						).toLocaleTimeString()}`
					}}
				</template>
				<template #item.action="{ item }">
					<div class="flex">
						<button
							class="btn--link btn--link--plus py-2 my-2"
							@click=";(selected = item), $modal.show('spv-saved-list')"
						>
							{{ $t(`button.more`) }}
						</button>
					</div>
				</template>
				<v-alert slot="no-results" :value="true" color="error">
					{{ $t('system_message.search') }}
				</v-alert>
			</v-data-table>

			<modal name="spv-saved-list" :width="1040" :min-width="550" :height="'auto'" :adaptive="true">
				<div class="modal__block--wrapper">
					<div class="modal__wrapper">
						<div class="modal__header">
							<div class="modal__title">
								{{ $t('spv_check.cross_check_summary') }}
							</div>
						</div>

						<div class="modal__content">
							<div v-if="selected" class="pl-4 py-2 flex items-start gap-2">
								<div>
									<strong>{{ $t(`labels.subject`) }}: </strong>
								</div>
								<div class="flex items-center justify-between">
									<div>
										<div v-if="selected.user.name_company">{{ selected.user.name_company }}</div>
										<div>
											{{
												`${selected?.user?.last_name || ''} ${selected?.user?.first_name || ''} ${
													selected?.user?.middle_name || ''
												}`
											}}
										</div>
									</div>
									<button
										class="inline-flex gap-[10px] items-center text-[#52A5FC] hover:no-underline mr-[25px]"
										@click.stop.prevent="downloadPdfReport(selected.id)"
									>
										{{ $t(`button.downloadPdf`) }}
									</button>
								</div>
							</div>
							<v-data-table
								v-if="selected"
								:headers="headersList"
								:items="selected.fishes"
								hide-default-footer
							>
								<template #item.allocated_volume="{ item }">
									{{ item.allocated_volume ?? 0 }}
								</template>
								<template #item.available_volume="{ item }">
									{{ item.available_volume ?? item.trade_volume }}
								</template>
								<template #item.status="{ item }">
									<span
										class="badge"
										:class="{
											'badge-success': item.status === 'sufficient',
											'badge-warning': item.status === 'insufficient',
										}"
									>
										{{ $t(`spv_check.${item.status}`) }}
									</span>
								</template>
							</v-data-table>
						</div>
					</div>
				</div>
			</modal>
		</div>
	</div>
</template>

<style scope>
/* Badge styling */
.badge {
	display: inline-block;
	padding: 4px 8px;
	font-size: 12px;
	font-weight: 500;
	line-height: 1;
	text-align: center;
	white-space: nowrap;
	vertical-align: baseline;
	border-radius: 4px;
}

.badge-success {
	background: #28a745;
	color: #ffffff;
}

.badge-secondary {
	background: #6c757d;
	color: #ffffff;
}

.badge-warning {
	background: #ffc107;
	color: #212529;
}
</style>
